import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Μεταφέρει το scroll στην κορυφή κάθε φορά που αλλάζει το pathname (το URL)
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Αυτό το component δεν δείχνει τίποτα στην οθόνη
}
